import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CommonExplainModule } from '../../common-explain/common-explain.module';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'modal-business-email',
  templateUrl: './modal-business-email.component.html',
  styleUrls: ['./modal-business-email.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    CommonExplainModule,
    MatIcon
  ]
})
export class ModalBusinessEmailComponent implements OnInit {
  @Input() generate?: () => Promise<any>;

  promise?: Promise<any>;
  state: 'loading' | 'error' = 'loading';

  constructor(
    private activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
    this.run();
  }

  run() {
    if (this.generate) {
      this.state = 'loading';
      this.promise = this.generate().then((result) => {
        this.activeModal.close(result);
      }).catch((error) => {
        console.error(error);
        this.state = 'error';
      });
    }
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
